module.exports = __webpack_public_path__ + "img/NO.edb20757.svg";